import React, { useEffect, useState } from "react";
import Select from "react-select";
import "./map-deals.css";
import "./segment-request.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiCallServices from "../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../services/endpoint/endPoint";
import SegmentRequestList from "./child/SegmentRequestList";
import button from "../../../button.module.css";
import SegmentRequestMultiselectCheckbox from "./child/SegmentRequestMultiselectCheckbox";

const SegmentRequest = () => {
  const [sendingMail, setSendingMail] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState([]);
  const [selectedFilterDsp, setSelectedFilterDsp] = useState([]);
  const [selectedFormDsp, setSelectedFormDsp] = useState([]);
  const [dspList, setDspList] = useState([]);
  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");
  const [loader, setLoader] = useState(false);
  const [selectedDemand, setSelectedDemand] = useState();
  const [selectedNewDemand, setSelectedNewDemand] = useState();
  const [showHideModal, setShowHideModal] = useState(false);
  const [modalType, setModalType] = useState(""); // view | edit
  const [selectedRow, setSelectedRow] = useState(null);
  const [emailToSend, setEmailToSend] = useState("");

  const handleViewUrl = (row) => {
    setSelectedRow(row);
    setModalType("view");
    setShowHideModal(true);
    document.body.style.overflow = "hidden";
  };

  const handleView = (row) => {
    setSelectedRow(row);
    setModalType("view");
    setShowHideModal(true);
    document.body.style.overflow = "hidden";
  };


  const handleEdit = (row) => {
    setSelectedRow(row);
    setEmailToSend("");
    setModalType("edit");
    setShowHideModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setShowHideModal(false);
    setSelectedRow(null);
    setEmailToSend("");
    document.body.removeAttribute("style");
  };

  const sendResolutionEmail = () => {
    if (!emailToSend) {
      toast.error("Email is required");
      return;
    }

    setSendingMail(true);

    ApiCallServices.create(END_POINTS.assignSegmentRequest, {
      id: selectedRow.id,
      resolutionEmail: emailToSend,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Resolution email sent");

          // Update assignedTo locally for instant UI feedback
          setSelectedRow((prev) => ({
            ...prev,
            assignedTo: prev?.assignedTo
              ? Array.from(
                  new Set([...prev.assignedTo.split(","), emailToSend])
                ).join(",")
              : emailToSend,
            status: "In-Process",
          }));

          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error || "Failed to send email");
      })
      .finally(() => {
        setSendingMail(false);
      });
  };

  const getSegmentRequestTableData = () => {
    setLoader(true);
    const data = {
      name: search,
      client_id: selectedFilterDsp?.id,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
    };
    ApiCallServices.create(END_POINTS.segmentRequestListing, data)
      .then((res) => {
        const data = res.data.data;
        if (res.status === 200) {
          setTableData(data);
          setLoader(false);
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(
            "error in getting response ====>",
            error.response.data.error
          );
          toast.error(error.response.data.error, {
            position: "top-right",
          });
        }
      });
  };

  useEffect(() => {
    getSegmentRequestTableData();
  }, [search, selectedFilterDsp, sortingColumn, sortingOrder]);

  const handleSort = (column) => {
    if (sortingColumn === column) {
      setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
    } else {
      setSortingColumn(column);
      setSortingOrder("asc");
    }
  };

  const downloadCSV = (data) => {
    if (!data || !data.length) {
      toast.warning("No data available to download");
      return;
    }

    const columns = [
      { header: "Referennce Code", key: "refCode" },
      { header: "Email", key: "email" },
      { header: "Contact_No", key: "phone" },
      { header: "Seat_Id", key: "seat_id" },
      { header: "DSP_Name", key: "dsp_name" },
      { header: "Deal Format", key: "dealFormat" },
      { header: "Deal_Name", key: "dealName" },
      { header: "Agency Code", key: "agencyCode" },
      { header: "Curator Margin", key: "margin" },
      { header: "Buying CPM", key: "cpm" },
      { header: "Request_On", key: "updated_on" },
      { header: "Status", key: "status" },
      { header: "Comment", key: "comment" },
    ];

    const csvRows = [
      columns.map((col) => col.header).join(","),
      ...data.map((row) =>
        columns
          .map(
            (col) =>
              `"${String(row[col.key] ?? "")
                .replace(/"/g, '""')
                .replace(/\n/g, " ")}"`
          )
          .join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "segment_requests.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const getDspList = () => {
    ApiCallServices.getlisting(END_POINTS.dspList)
      .then((res) => {
        if (res.status === 200) {
          setDspList(res.data.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
        }
      });
  };

  useEffect(() => {
    getDspList();
  }, []);

  const handleDspChange = (values) => {
    setSelectedFilterDsp(values);
  };

  const handleFormDspChange = (values) => {
    setSelectedFormDsp(values);
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#fff"
        : state.isFocused
        ? "#6abfe94d"
        : undefined,
      color: state.isSelected ? "white" : "black",
      padding: 10,
      display: "flex",
      alignItems: "center",
    }),
  };

  const searchSegmentRequest = (e) => {
    if (e.target.value.length > 1) {
      setSearch(e.target.value);
    } else {
      setSearch("");
    }
  };

  const updateStatus = ({ id, status }) => {
    // setLoader(true);

    ApiCallServices.create(END_POINTS.updateSegmentRequestStatus, {
      id,
      status,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Status updated successfully");

          // Optimistic UI update (NO extra API call needed)
          setTableData((prev) =>
            prev.map((row) => (row.id === id ? { ...row, status } : row))
          );
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Failed to update status");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Deal Requests</h3>
          </div>
      </div>

        <div className="filter-wraper justify-content-between">
          <div className="d-flex align-items-center fields">
            <div className="form-group search-icon">
              <input
                type="text"
                className="form-control"
                onChange={searchSegmentRequest}
                placeholder="Search by email , seat id "
              />
            </div>
            <div className="form-group custome-select">
              <Select
                placeholder="Select DSP"
                value={selectedFilterDsp}
                isClearable="true"
                onChange={handleDspChange}
                options={dspList}
                getOptionLabel={(dspList) => dspList.name}
                getOptionValue={(dspList) => dspList.id}
              />
            </div>
          </div>
          <div>
            <i
              style={{
                marginLeft: "10px",
                fontSize: "25px",
                marginTop: "5px",
                color: "#0a58ca",
                cursor: "pointer",
              }}
              class="fa-solid fa-download"
              onClick={() => downloadCSV(tableData)}
            ></i>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        </div>
        <SegmentRequestList
          tableData={tableData}
          onSort={handleSort}
          loader={loader}
          updateStatus={updateStatus}
          onView={handleView}
          onEdit={handleEdit}
        />

        <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  {modalType === "view"
                    ? "Deal Request Details"
                    : "Assign To Email"}
                </h4>

                <i
                  className="fa-regular fa-circle-xmark close-icon"
                  onClick={closeModal}
                ></i>
              </div>

              <div className="modal-body">
                {modalType === "view" && selectedRow && (
                  <div className="form-wraper view-details">
                    <div className="detail-row">
                      <span className="detail-label">Reference Code</span>
                      <span className="detail-value">
                        {selectedRow.refCode || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Email</span>
                      <span className="detail-value">
                        {selectedRow.email || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Contact No</span>
                      <span className="detail-value">
                        {selectedRow.phone || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Seat ID</span>
                      <span className="detail-value">
                        {selectedRow.seat_id || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">DSP Name</span>
                      <span className="detail-value">
                        {selectedRow.dsp_name || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Deal Format</span>
                      <span className="detail-value">
                        {selectedRow.dealFormat || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Deal Name</span>
                      <span className="detail-value">
                        {selectedRow.dealName || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Curator Margin</span>
                      <span className="detail-value">
                        {selectedRow.margin ?? "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Buying CPM</span>
                      <span className="detail-value">
                        {selectedRow.cpm ?? "N/A"}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Agency Code</span>
                      <span className="detail-value">
                        {selectedRow.agencyCode ?? "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Comment</span>
                      <span
                        className="detail-value"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {selectedRow.comment || "N/A"}
                      </span>
                    </div>


                    <div className="detail-row">
                      <span className="detail-label">Requested URLs</span>
                      <span
                        className="detail-value"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {selectedRow.urls || "N/A"}
                      </span>
                    </div>



                    <div className="detail-row">
                      <span className="detail-label">Assigned To</span>
                      <span className="detail-value">
                        {selectedRow.assignedTo || "N/A"}
                      </span>
                    </div>

                    <div className="detail-row">
                      <span className="detail-label">Status</span>
                      <span
                        className={`detail-badge status-${selectedRow.status
                          ?.toLowerCase()
                          .replace(/\s/g, "")}`}
                      >
                        {selectedRow.status}
                      </span>
                    </div>
                  </div>
                )}

                {modalType === "edit" && selectedRow && (
                  <div className="form-wraper">
                    {/* Assigned To (existing emails) */}
                    <div className="detail-row mb-2">
                      <span className="detail-label">Assigned To</span>
                      <span className="detail-value">
                        {selectedRow.assignedTo?.split(",")?.join(", ") ||
                          "Not assigned yet"}
                      </span>
                    </div>

                    <br />
                    {/* Email input */}
                    <div className="form-group">
                      <div className="detail-row mb-2">
                        <span className="detail-label">Email:</span>
                        <span className="detail-value">
                          {" "}
                          <input
                            type="email"
                            className="form-control"
                            value={emailToSend}
                            onChange={(e) => setEmailToSend(e.target.value)}
                            placeholder="Enter email"
                            disabled={sendingMail}
                          />
                        </span>
                      </div>
                    </div>

                    {/* Action */}
                    <div className="text-end">
                      <button
                        className={`${button.btn} ${button.btnBlue}`}
                        onClick={sendResolutionEmail}
                        disabled={sendingMail}
                      >
                        {sendingMail ? (
                          <>
                            <i className="fa fa-spinner fa-spin me-2"></i>
                            Sending...
                          </>
                        ) : (
                          "Assign Request"
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={`${showHideModal ? "overlay" : ""}`}></div>
      </div>
    </>
  );
};

export default SegmentRequest;
